<template lang="pug">
section.section-content.section-content--browser-log
    .box
        header.flex.items-center.justify-between.box__header.no-border
            .header-meta
                h2.subheading Browser Log
            .header-cta

        .box__body
            .box-tabs
                vue-tabs
                    v-tab(title="Certificate")
                        LogCertificate
                    v-tab(title="Signal")
                        LogSignal

                    v-tab(title="Data Usage")
                        LogDataUsage
                    
                    v-tab(title="Browser")
                        LogBrowser
</template>

<script>
import {VueTabs, VTab} from 'vue-nav-tabs'

import LogCertificate from './../browsing/log/Certificate.vue'
import LogSignal from './../browsing/log/Signal.vue'
import LogDataUsage from './../browsing/log/LogDataUsage.vue'
import LogBrowser from './../browsing/log/Browser.vue'

export default {
    name: 'HistoryBrowsingBrowsingLog',
    components: {
        VueTabs,
        VTab,
        LogCertificate,
        LogSignal,
        LogDataUsage,
        LogBrowser,
    },
}
</script>

<style lang="sass">

</style>
